function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/********************************************************************************
 * Copyright (C) 2021 Ant Group and others.
 *
 * Date 2021-05-18 11:21:41.
 * Have a nice day.
 ********************************************************************************/

/* eslint-disable @typescript-eslint/no-explicit-any */

export var Disposable;
(function (_Disposable) {
  function is(arg) {
    return !!arg && _typeof(arg) === 'object' && 'dispose' in arg && typeof arg.dispose === 'function';
  }
  _Disposable.is = is;
  function create(func) {
    return {
      dispose: func
    };
  }
  _Disposable.create = create;
  var NONE = _Disposable.NONE = create(function () {});
})(Disposable || (Disposable = {}));
export var Disposed;
(function (_Disposed) {
  function is(arg) {
    return !!arg && _typeof(arg) === 'object' && 'disposed' in arg && typeof arg.disposed === 'boolean';
  }
  _Disposed.is = is;
})(Disposed || (Disposed = {}));